import { logger } from '../core/utils/logger';
export const loadChartLibrary = () => {
  return import('chart.js/auto').then(module => module.default);
};

export const loadFramerMotion = () => {
  return import('framer-motion').then(module => ({
    motion: module.motion,
    AnimatePresence: module.AnimatePresence,
    useAnimation: module.useAnimation
  }));
};

export const loadReactChartjs = () => {
  return import('react-chartjs-2').then(module => ({
    Line: module.Line,
    Bar: module.Bar,
    Doughnut: module.Doughnut,
    Pie: module.Pie
  }));
};

export const loadDateLibrary = () => {
  return import('date-fns').then(module => ({
    format: module.format,
    parseISO: module.parseISO,
    subDays: module.subDays,
    startOfDay: module.startOfDay,
    endOfDay: module.endOfDay
  }));
};

export const loadExportLibrary = () => {
  return import('exceljs').then(module => module.default || module);
};

export const preloadCriticalLibraries = () => {
  if (typeof window !== 'undefined') {
    const criticalImports = [
      loadDateLibrary
    ];

    criticalImports.forEach(importFn => {
      setTimeout(() => {
        importFn().catch(err => {
          logger.warn('Failed to preload library:', err);
        });
      }, 100);
    });
  }
};

export const preloadAdminLibraries = () => {
  if (typeof window !== 'undefined' && window.location.pathname.includes('/admin')) {
    const adminImports = [
      loadChartLibrary,
      loadReactChartjs,
      loadExportLibrary
    ];

    adminImports.forEach(importFn => {
      setTimeout(() => {
        importFn().catch(err => {
          logger.warn('Failed to preload admin library:', err);
        });
      }, 200);
    });
  }
};
